import { render, staticRenderFns } from "./BlockTextImage.vue?vue&type=template&id=10f99331&"
import script from "./BlockTextImage.vue?vue&type=script&lang=js&"
export * from "./BlockTextImage.vue?vue&type=script&lang=js&"
import style0 from "./BlockTextImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports